<!--Banner-->
<div class="games-banner pb-lg-3" [ngClass]="{ 'show-footer': showFooter }">
  <div class="container">
    <a class="games-banner-buttons d-lg-flex d-none text-white align-items-center" [routerLink]="['/games']">
      <i class="material-icons">chevron_left</i>
      <span class="font-size-14 fw-bold">{{ 'games.banner.back.title' | translate }}</span>
    </a>
    <div class="text-center pt-2">
      <img *ngIf="isPollsPage" class="games-banner-img" [src]="'games/polls-banner.png' | contentAssetImage" />
      <img *ngIf="isTriviaPage" class="games-banner-img" [src]="'games/trivia-banner.png' | contentAssetImage" />
      <img *ngIf="isPredictorPage" class="games-banner-img" [src]="'games/predictor-banner.png' | contentAssetImage" />
    </div>
  </div>
  <div class="text-center pt-2">
    <ng-container *ngIf="!isPollsPage">
      <div class="container navbar-container">
        <nav class="nav leaderboard-nav">
          <div class="nav-item">
            <a
              *ngIf="isTriviaPage"
              [routerLink]="'/games/trivia'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.play' | translate }}

              <div class="active-border"></div>
            </a>

            <a
              *ngIf="isPredictorPage"
              [routerLink]="'/games/predictor'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.play' | translate }}

              <div class="active-border"></div>
            </a>
          </div>

          <div class="nav-item">
            <a
              *ngIf="isTriviaPage"
              [routerLink]="'/games/trivia/leaderboard'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.leaderboard' | translate }}

              <div class="active-border"></div>
            </a>

            <a
              *ngIf="isPredictorPage"
              [routerLink]="'/games/predictor/leaderboard'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.leaderboard' | translate }}

              <div class="active-border"></div>
            </a>
          </div>
        </nav>
      </div>
    </ng-container>
  </div>
</div>
